import { styled } from "twin.macro";
import { DivWithWidth } from "./IPopover";

export const StylePopoverContainer = styled.div(
  ({ width }: DivWithWidth<object>) => ({
    width: `${width}px`,
  })
);
